module.exports = __webpack_public_path__ + "static/media/how-seo-illustr-2.6865316d.png";